// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popUpNotifications_MPpp1 {
    position: fixed;
    bottom: 10px;
    right: 10px;
    background-color: var(--white-background);
    width: 350px;
    border: 1px solid var(--ececf1-border);
    border-radius: 10px;
    box-shadow: -2px -2px 22px -11px var(--black-color);
    z-index: 9999;



    .content_NMF_E {
        padding: 20px 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        text-align: center;
        justify-content: space-between;
        gap: 10px;


        span {
            font-weight: bolder;
            font-size: 20px;
            color: #210348;
        }

        p {
            color: #000000;
            margin: 0;
        }
    }
}
.spinner_VVze4 {
  width: 15px;
  height: 15px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid #10a37f; 
  border-radius: 50%;
  animation: spin_QrMO1 1s linear infinite;
  margin-right: 10px;
}

@keyframes spin_QrMO1 {
  to {
    transform: rotate(360deg);
  }
}

.leftContent_P_99Q{
    display: flex;
    flex-direction: row;
    gap: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Notification/Notification.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,yCAAyC;IACzC,YAAY;IACZ,sCAAsC;IACtC,mBAAmB;IACnB,mDAAmD;IACnD,aAAa;;;;IAIb;QACI,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;QAClB,8BAA8B;QAC9B,SAAS;;;QAGT;YACI,mBAAmB;YACnB,eAAe;YACf,cAAc;QAClB;;QAEA;YACI,cAAc;YACd,SAAS;QACb;IACJ;AACJ;AACA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,6BAA6B;EAC7B,kBAAkB;EAClB,wCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb","sourcesContent":[".popUpNotifications {\n    position: fixed;\n    bottom: 10px;\n    right: 10px;\n    background-color: var(--white-background);\n    width: 350px;\n    border: 1px solid var(--ececf1-border);\n    border-radius: 10px;\n    box-shadow: -2px -2px 22px -11px var(--black-color);\n    z-index: 9999;\n\n\n\n    .content {\n        padding: 20px 10px;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        text-align: center;\n        justify-content: space-between;\n        gap: 10px;\n\n\n        span {\n            font-weight: bolder;\n            font-size: 20px;\n            color: #210348;\n        }\n\n        p {\n            color: #000000;\n            margin: 0;\n        }\n    }\n}\n.spinner {\n  width: 15px;\n  height: 15px;\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-top: 4px solid #10a37f; \n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-right: 10px;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.leftContent{\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popUpNotifications": `popUpNotifications_MPpp1`,
	"content": `content_NMF_E`,
	"spinner": `spinner_VVze4`,
	"spin": `spin_QrMO1`,
	"leftContent": `leftContent_P_99Q`
};
export default ___CSS_LOADER_EXPORT___;
